import axios from "axios";

import { ApiService } from "../../../servicios/api.service";
import LocalStorageKeys from "../../../data/localStorageKeys";

export class BeneficioApi {
  static endPoint = "comerciante/beneficio/";

  static get BasePath() {
    return ApiService.api + this.endPoint;
  }

  static get AuthHeader() {
    return "Bearer " + localStorage.getItem(LocalStorageKeys.tokenComercio);
  }

  static get Headers() {
    return { Authorization: this.AuthHeader };
  }

  static get Config() {
    return { headers: this.Headers };
  }

  static countWithFilter(filter) {
    return axios.post(this.BasePath + "filter/count", filter, this.Config);
  }

  static create(data) {
    return axios.post(this.BasePath, data, this.Config);
  }

  static deleteById(id) {
    return axios.delete(this.BasePath + id, this.Config);
  }

  static getListWithFilter(filter) {
    return axios.post(this.BasePath + "filter/", filter, this.Config);
  }

  static getTipoDescuentoList() {
    return axios.get(ApiService.api + "tiposdescuentos/mio", this.Config);
  }

  static getUnidadesDescuentoList() {
    return axios.get(ApiService.api + "descuentos/unidades/comerciante", this.Config);
  }

  static update(data) {
    return axios.patch(this.BasePath, data, this.Config);
  }
}
